import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'

export const useTableColumnRmName = () => ({
    title: '规则名称',
    dataIndex: 'rmName',
    component: <Table.ViewText />,
})

export const useTableColumnRmNo = () => ({
    title: '规则代码',
    dataIndex: 'rmNo',
    component: <Table.ViewText />,
})

const TableChooseRulemrm = (props) => {
    const columns = [
        useTableColumnRmNo(),
        useTableColumnRmName(),
    ]

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseRulemrm
